{
  "info": "Информация",
  "negative": "Ошибка",
  "notice": "Предупреждение",
  "positive": "Успешно"
}
